import axiosInstance from "../auth/FetchInterceptor";
import {
  PURCHASE_SUMMARY_CARDS,
  PURCHASE_REQUEST_ORDER_STATUS_DISTRIBUTION,
  PURCHASE_PURCHASE_ORDER_STATUS_DISTRIBUTION,
  PURCHASE_TOP_BRANCH,
  PURCHASE_TOP_REQUEST_ITEMS,
  PURCHASE_TOP_SUPPLIERS,
  PURCHASE_PAYMENT_SUMMARY,
  PURCHASE_SUPPLIER_DEBT_SUMMARY,
  PURCHASE_SUPPLIER_DEBT_LIST,
  PURCHASE_EXPORT_EXCEL,
} from "constants/ApiConstant";
import { withCurrentStore } from "utils/currentStore";

const PurchaseReportService = {};

const withReportStore = (data) => withCurrentStore(data, "storeId");

PurchaseReportService.purchaseReportSummaryCards = function (data) {
  return axiosInstance.post(PURCHASE_SUMMARY_CARDS, withReportStore(data));
};

PurchaseReportService.purchaseReportRequestOrderStatusDistribution = function (data) {
  return axiosInstance.post(
    PURCHASE_REQUEST_ORDER_STATUS_DISTRIBUTION,
    withReportStore(data),
  );
};

PurchaseReportService.purchaseReportPurchaseOrderStatusDistribution = function (data) {
  return axiosInstance.post(
    PURCHASE_PURCHASE_ORDER_STATUS_DISTRIBUTION,
    withReportStore(data),
  );
};

PurchaseReportService.purchaseReportTopBranches = function (data) {
  return axiosInstance.post(PURCHASE_TOP_BRANCH, withReportStore(data));
};

PurchaseReportService.purchaseReportTopRequestItems = function (data) {
  return axiosInstance.post(PURCHASE_TOP_REQUEST_ITEMS, withReportStore(data));
};

PurchaseReportService.purchaseReportTopSuppliers = function (data) {
  return axiosInstance.post(PURCHASE_TOP_SUPPLIERS, withReportStore(data));
};

PurchaseReportService.purchaseReportPaymentSummary = function (data) {
  return axiosInstance.post(PURCHASE_PAYMENT_SUMMARY, withReportStore(data));
};

PurchaseReportService.purchaseReportSupplierDebtSummary = function (data) {
  return axiosInstance.post(PURCHASE_SUPPLIER_DEBT_SUMMARY, withReportStore(data));
};

PurchaseReportService.purchaseReportSupplierDebtList = function (data) {
  return axiosInstance.post(PURCHASE_SUPPLIER_DEBT_LIST, withReportStore(data));
};

PurchaseReportService.exportExcel = function (params) {
  return axiosInstance.post(PURCHASE_EXPORT_EXCEL, withReportStore(params), {
    responseType: "blob",
  });
};

export default PurchaseReportService;